import { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

// Merging policy for APIs using nodes field flattened API
// instead of standard relay style specification
const _defaultNodesPaginationMerge = (existing, incoming) => {
  const existingNodes = existing?.nodes || [];
  const incomingNodes = incoming.nodes;

  return {
    pageInfo: incoming.pageInfo,
    nodes: [...existingNodes, ...incomingNodes],
  };
};

// Generate a default policy for pagination merging
const createDefaultPolicy = (
  typename: string,
  field: string,
  keyArgs?: string[]
): TypePolicies => {
  return {
    [typename]: {
      fields: {
        [field]: relayStylePagination(keyArgs),
      },
    },
  };
};

const GET_PUBLISHED_FOLDERS = createDefaultPolicy(
  'GetPublishedFoldersPayload',
  'folders',
  ['parentFolderId', 'source', 'sortOrder', 'sortType', 'filters', 'timeRange']
);

const GET_LOOMS = createDefaultPolicy('GetLoomsPayload', 'videos', [
  'folderId',
  'source',
  'sortType',
  'sortOrder',
  'filters',
  'timeRange',
]);

const GET_NOTIFICATIONS = createDefaultPolicy(
  'GetNotificationsPayload',
  'notifications',
  ['notificationType']
);

const GET_PROFILE_VIDEOS = createDefaultPolicy(
  'RegularUserProfile',
  'profileVideos',
  ['sortType, sortOrder']
);

const GET_SCREENSHOTS = createDefaultPolicy(
  'GetScreenshotsPayload',
  'screenshots',
  ['source']
);

const GET_USER_GROUPINGS = createDefaultPolicy(
  'UserGroupingsPayload',
  'entries',
  ['userId', 'workspaceId', 'groupingType']
);

const GET_WORKSPACE_GROUPINGS = createDefaultPolicy(
  'WorkspaceGroupingsPayload',
  'entries',
  ['workspaceId', 'groupingType', 'tag']
);

export const typePolicies: TypePolicies = {
  ...GET_PUBLISHED_FOLDERS,
  ...GET_LOOMS,
  ...GET_NOTIFICATIONS,
  ...GET_PROFILE_VIDEOS,
  ...GET_SCREENSHOTS,
  ...GET_USER_GROUPINGS,
  ...GET_WORKSPACE_GROUPINGS,
  // Add additional type policies here
  // ...
};
